import script from "./UpdateNotificationModal.vue?vue&type=script&setup=true&lang=js"
export * from "./UpdateNotificationModal.vue?vue&type=script&setup=true&lang=js"

import "./UpdateNotificationModal.vue?vue&type=style&index=0&id=4054c33d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4054c33d"]])

export default __exports__